import { render, staticRenderFns } from "./LookingForProduct.vue?vue&type=template&id=68cc52f2"
import script from "./LookingForProduct.vue?vue&type=script&lang=js"
export * from "./LookingForProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports